/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { TREATMENT_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { TreatmentPage } from "@/features/processing/components/treatment-page";

export const Route = createFileRoute("/_app/processing/treatment/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(TREATMENT_FORM))
      throw redirect({ to: "/processing/treatment" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <TreatmentPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
